import { useMutation } from '@tanstack/react-query'

import sessionMetadataService from '../lib/services/sessionService'
import { initialiseSessionSuccess } from '../redux/slices/session'
import useAppDispatch from './useAppDispatch'
import { useShowGenericServerError } from './useShowGenericServerError'

export function useRefreshSessionMetadataMutation() {
  const dispatch = useAppDispatch()
  const showGenericServerError = useShowGenericServerError()

  return useMutation({
    mutationFn: async () => {
      const sessionMetadata =
        await sessionMetadataService.createSessionMetadata()

      dispatch(
        initialiseSessionSuccess({
          metadata: sessionMetadata,
        }),
      )
    },
    onError: showGenericServerError,
  })
}
